import { Fetcher } from '@Types/fetcher'
import useShopifyFetcher from '../shopify'

function useConnectApp(): Fetcher {
  const [baseFetcher, meta] = useShopifyFetcher()

  const connectAppFetcher = async (url: string, method?: string) => {
    return await baseFetcher(
      url,
      {
        method: method ?? 'POST',
        headers: { 'Content-Type': 'application/json' },
      },
      (_, hasError) =>
        !hasError
          ? history.replaceState(null, '', window.location.pathname)
          : null,
    )
  }

  return [connectAppFetcher, meta]
}

export default useConnectApp
